import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import MessageModal from '../container/MessageModal';
import SimpleMDE from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";
import { Form } from 'react-bootstrap';
import TextControl from '../container/customizedInputs/TextControl';
import { errorClassification } from '../errorHandler';

import ofertasServices from '../services/ofertasServices';
import resourcesServices from '../services/resourcesServices';

const OfertaForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [detalle, setDetalle] = useState();
  const [oferta, setOferta] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [renderHTML, setRenderHTML] = useState(false);
  const [saving, setSaving] = useState(false);

  const [cargos, setCargos] = useState([]);
  const [tiposOfertas, setTiposOfertas] = useState({});
  const [materialEstudios, setMaterialEstudios] = useState([]);
  const [materialEstudiosOferta, setMaterialEstudiosOferta] = useState([]);
  const [estados, setEstados] = useState([]);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    if(id){
      fetchOferta(id)
    } else {
      nuevaOferta()
    }

    fetchGeneral()
  }, [id]);

  useEffect(() => {
    const aux = [];
    if( Array.isArray(materialEstudios) && Array.isArray(oferta.material_estudios_ofertas) ){
      const aux = []
      materialEstudios.forEach((me) => {
        const selected = oferta.material_estudios_ofertas.filter(t => t["material_estudio_id"] == me.id)
        if(selected.length === 1){
          aux.push({...selected[0], ...{_destroy: 0, nombre: me.nombre}})
        } else {
          aux.push({material_estudio_id: me.id, nombre: me.nombre, _destroy: 1})
        }

      });
      setMaterialEstudiosOferta(aux)
    }
  }, [materialEstudios, oferta.material_estudios_ofertas]);


  useEffect(() => {
    setOferta({...oferta,
        'detalle': detalle
    })
  }, [detalle]);


  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchOferta = async (id) => {
    try {
      const data = await ofertasServices.obtenerOfertaPorId(id);
      data.adjuntos.push({
        titulo: '',
        archivo: '',
      })
      data.documentaciones.push({
        nombre: '',
      })
      setOferta(data);
      setDetalle(data.detalle)
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const fetchGeneral = async () => {
    try {
      const data_material = await resourcesServices.obtenerResources('material_estudios', '', '', '', '');
      setMaterialEstudios(data_material.data);

      const data_cargos = await ofertasServices.obtenerCargos();
      setCargos(data_cargos)

      const data_ofertas = await ofertasServices.tiposOfertas();
      setTiposOfertas(data_ofertas)

      const data_estados = await resourcesServices.obtenerResourcePorId('ofertas', 'estados');
      setEstados(data_estados);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const nuevaOferta = async (id) => {
    try {
      const data = await ofertasServices.nuevaOferta();
      data.documentaciones.push({
        nombre: '',
      })
      setOferta(data);
      setDetalle("")
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const actualizarOferta = async () => {
    try {
      setSaving(true)

      const copiaOferta = {...oferta}
      copiaOferta.adjuntos_attributes = copiaOferta.adjuntos || []
      copiaOferta.documentaciones_attributes = copiaOferta.documentaciones || []
      copiaOferta.material_estudios_ofertas_attributes = materialEstudiosOferta || []
      delete copiaOferta.adjuntos
      delete copiaOferta.documentaciones

      // Tamaño máximo permitido (por ejemplo 50 MB)
      const maxSizeMB = 50;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      let conError = false
 
      copiaOferta.adjuntos_attributes?.forEach((archivo) => {
        if(archivo.archivo && archivo.archivo.size){

          if (archivo.archivo.size > maxSizeBytes) {
            conError = true
            alert(`El archivo de nombre ${archivo.archivo.name} supera el límite de ${maxSizeMB} MB`);
          }
        }
      });

      if(conError){
        setSaving(false)
        return;
      }

      let data;
      if(esNuevo){
        data = await ofertasServices.crearOferta({oferta: copiaOferta});
        setSaving(false)
        navigate(`/oferta/${data.id}/edit`);
      } else {
        data = await ofertasServices.actualizarOferta(oferta.id, {oferta: copiaOferta});
        setOferta(data);
        setDetalle(data.detalle)
        setSaving(false)
      }


    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarDocumentacion = async (documento_id) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar la documentación?`)){
        const data = await ofertasServices.actualizarOferta(oferta.id, {oferta: {documentaciones_attributes: [{id: documento_id, "_destroy": 1}]}});
        setOferta(data);
        setDetalle(data.detalle)
      }
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  }

  const quitarDocumentacion = async (idx) => {
    const docs = oferta.documentaciones
    docs.splice(idx, 1);
    setOferta({...oferta,
      ['documentaciones']: docs
    })
  }

  const agregarDocumentacion = () => {
    setOferta({...oferta,
      ['documentaciones']: oferta.documentaciones.concat({nombre: ""})
    })
  }

  const eliminarAdjuntoOferta = async (adjunto_id) => {
    try {
        const data = await ofertasServices.eliminarAdjuntoOferta(oferta.id, adjunto_id);
        setOferta({...oferta,
          adjuntos: data.adjuntos,
        })
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const onChangeDetalle = useCallback((value: string) => {
    setDetalle(value);
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    if(name === 'activo'){
      setOferta({...oferta,
        [name]: !oferta.activo
      })
    } else if(name === 'estado_abierto'){
      setOferta({...oferta,
        [name]: !oferta.estado_abierto
      })
    } else if(name === 'es_publica'){
      setOferta({...oferta,
        [name]: !oferta.es_publica
      })
    } else {
      setOferta({...oferta,
        [name]: value
      })
    }
  }

  const handleInputMaterialEstudio = (e, me_id) => {
    const { name, value, checked } = e.target;

    const updatedItems = materialEstudiosOferta.map(item =>
      item.material_estudio_id === me_id ? { ...item, _destroy: checked ? 0 : 1 } : item
    );

    setMaterialEstudiosOferta(updatedItems)
  }

  const handleInputNested = (e, index) => {
    const { name, value, checked, type } = e.target;

    const [parentKey, childKey] = name.split('.');

    const copiaOferta = {...oferta}

    if(type==='checkbox'){
      copiaOferta.documentaciones[index][childKey] =  checked
    } else {
      copiaOferta.documentaciones[index][childKey] =  value
    }

    setOferta({...oferta,
      ['documentaciones']: copiaOferta.documentaciones
    })
  }

  const handleInputAdjuntos = (e, index) => {
    const { name, value, files } = e.target;

    const copiaOferta = {...oferta}

    if(name === 'archivo'){
      copiaOferta.adjuntos[index][name] = files[0]
    } else if (name === 'es_condicion') {
      copiaOferta.adjuntos[index][name] = !copiaOferta.adjuntos[index][name]
    } else {
      copiaOferta.adjuntos[index][name] = value
    }

    setOferta(copiaOferta)
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    actualizarOferta()
  }

  const agregarAdjunto = () => {
    const data = {...oferta}
    data.adjuntos.push({
      titulo: '',
      archivo: '',
    })

    setOferta(data)
  }

  const renderizarAdjunto = (adjunto, index) => {
    return (<>
      <div className='card mb-3'>
        <div className='card-body'>
        <div className='card-text'>
          <input
            type="text"
            name="titulo"
            id={`adjuntos_attributes.${index}.title`}
            className="form-control"
            placeholder='Ingrese un título para el adjunto'
            value={adjunto.titulo || ''}
            onChange={(e) => handleInputAdjuntos(e, index)}
            />

          <Form.Check
            type="switch"
            name="es_condicion"
            id={`adjuntos_attributes.${index}.es_condicion`}
            checked={ adjunto.es_condicion || ''}
            onChange={(e) => handleInputAdjuntos(e, index)}
            value={adjunto.es_condicion}
            label={'Es una condición'}
            />

          <input
            placeholder="Adjunte su foto"
            className="form-control"
            onChange={(e) => handleInputAdjuntos(e, index)}
            name="archivo"
            type="file"
            id={`adjuntos_attributes.${index}.archivo`}
          />
        </div>
        {
          adjunto.id && (
          <div className='text-end mt-3'>
            <a href={adjunto.archivoUrl} target="_blank" className="btn btn-primary" role="button" aria-disabled="true">Descargar</a>
            {' '}
            <button type="button" onClick={() => eliminarAdjuntoOferta(adjunto.id)} className="btn btn-danger">Eliminar</button>
          </div>
          )
        }
        </div>
      </div>
    </>)
  }

  return (
    <>
    {
      renderHTML &&  (
      <>
      <h1>Concurso</h1>
      <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
        <form encType='multipart/form-data'>
          <div className="mb-3">
            <label htmlFor="titulo" className="form-label">Título</label>
            <input
              type="text"
              name="titulo"
              className="form-control"
              value={oferta.titulo || ''}
              onChange={(e) => handleInput(e)}
              id="titulo" />
          </div>
          <div className="mb-3">
            <select value={oferta.cargo_id || 0} className="form-select" name="cargo_id" onChange={(e) => handleInput(e)}>
              <option value={0}>Elija un cargo</option>
              {cargos.map(cargo => (
                <option key={cargo.id} value={cargo.id}>{cargo.codigo} - {cargo.nombre}</option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <select value={oferta.tipos || 0} className="form-select" name="tipos" onChange={(e) => handleInput(e)}>
              <option value={0}>Elija un tipo de concurso</option>
              {Object.keys(tiposOfertas).map((tipo) => (
                <option key={tipo} value={tipo}>{tiposOfertas[tipo]}</option>
              ))}
            </select>
          </div>

          <SimpleMDE value={detalle} onChange={onChangeDetalle} />
          {
            oferta.adjuntos && (
              <div className="my-3 py-3 border-top border-3">
                <h3>Adjuntos para el postulante</h3>
                <div className="form-text mb-3">
                  Son los archivos que el usuario va a ver en el concurso y podrá descargar
                </div>

                <div className='row'>
                {

                  oferta.adjuntos && oferta.adjuntos.map((adjunto, index) => (
                    <div className='col-6' key={index}>
                      {renderizarAdjunto(adjunto, index)}
                    </div>
                  ))

                }
                  <div className='col-6'>
                    <button className="btn btn-sm btn-primary w-100 py-2" onClick={agregarAdjunto} type="button">Agregar adjunto</button>
                  </div>
                </div>
              </div>
            )
          }

          <div className="my-3 py-3 border-top border-3">
            <h3>Documentación requerida / opcional</h3>
            <div className="form-text mb-3">
              Indique el nombre de la documentación que el postulante debe adjuntar al postularse. Ejemplo: DNI, Currículum, etc<br />
              La documentación también puede ser opcional
            </div>
            <div className="row">
            {
              oferta.documentaciones && oferta.documentaciones.length > 0 && oferta.documentaciones.map((documentacion, index) => (
                <div key={index} className="col-7">
                  <div className="input-group mb-3">
                    <TextControl
                      value={documentacion.nombre || ''}
                      name={'documentaciones.nombre'}
                      handleInput={(e) => handleInputNested(e, index)}
                      type={'text'}
                      label={'Nombre'}
                      />

                  {
                    documentacion.id ? (
                      <>
                        <input
                          value={documentacion.id || ''}
                          name={'documentaciones.id'}
                          type={'hidden'}
                        />
                        <button className="btn btn-danger" onClick={() => eliminarDocumentacion(documentacion.id)} type="button">-</button>
                      </>
                      ) : (
                        index > 0 && (
                          <>
                            <button className="btn btn-danger" onClick={() => quitarDocumentacion(index)} type="button">-</button>
                          </>
                          )
                        )
                  }
                  <div className="form-check ms-1">
                    <input
                      name={'documentaciones.opcional'}
                      className="form-check-input"
                      type="checkbox"
                      checked={documentacion.opcional}
                      onChange={(e) => handleInputNested(e, index)}
                      id={`flexCheckDefault${index}`}
                    />
                    <label className="form-check-label" htmlFor={`flexCheckDefault${index}`}>
                      Es opcional
                    </label>
                  </div>
                  </div>
                </div>
              ))
            }
            </div>
            <button className="btn btn-sm btn-primary me-1" onClick={agregarDocumentacion} type="button">Agregar documentación</button>

          </div>

          <div className="my-3 py-3 border-top border-3">
            <h3>Material de estudio</h3>

            {
              materialEstudiosOferta.map((me) => (
                <div key={me.material_estudio_id} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={`${me.material_estudio_id}`}
                    name={`material_estudio_ids[]`}
                    id={`checkbox${me.id}`}
                    onChange={(e) => handleInputMaterialEstudio(e, me.material_estudio_id)}
                    checked={me["_destroy"] == 0}
                  />
                  <label className="form-check-label" htmlFor={`checkbox${me.material_estudio_id}`}>
                    {me.nombre}
                  </label>
                </div>
              ))
            }
          </div>



          {/* <pre>{JSON.stringify(materialEstudiosOferta, null, 2)}</pre> */}
          {/* <div className="mb-3 form-check">
            <Form.Check type="switch" checked={oferta.activo || ''} onChange={(e) => handleInput(e)} name="activo" id="activo" label="Activo" />
          </div> */}
          {/* <div className="mb-3 form-check">
            <Form.Check type="switch" checked={oferta.estado_abierto || ''} onChange={(e) => handleInput(e)} name="estado_abierto" id="estado_abierto" label="Vigente" />
          </div>
          <div className="mb-3 form-check">
            <Form.Check type="switch" checked={oferta.es_publica || ''} onChange={(e) => handleInput(e)} name="es_publica" id="es_publica" label="Es Pública" />
          </div> */}

          <div className="mb-3 w-50">
            <label>Fecha inicio de inscripción:</label>
            <Form.Control type="date" value={oferta.fecha_desde || ''} onChange={(e) => handleInput(e)} name="fecha_desde" placeholder="Fecha inicio de inscripción" />
          </div>
          <div className="mb-3 w-50">
            <label>Fecha límite de inscripción:</label>
            <Form.Control type="date" value={oferta.fecha_hasta || ''} onChange={(e) => handleInput(e)} name="fecha_hasta" placeholder="Fecha límite de inscripción" />
          </div>

          <div className="mb-3">
            <select value={oferta.estado || 0} className="form-select" name="estado" onChange={(e) => handleInput(e)}>
              <option value={0}>Elija el estado</option>
              {Object.keys(estados).map((estado) => (
                <option key={estado} value={estado}>{estados[estado]}</option>
              ))}
            </select>
          </div>

          <div className="form-check ms-1">
            <input
              name={'activo'}
              className="form-check-input"
              type="checkbox"
              checked={oferta.activo}
              onChange={() => setOferta({...oferta, ['activo']: (oferta.activo === true ? false : true)})}
              id={`flexCheckDefaultEstado`}
            />
            <label className="form-check-label" htmlFor={`flexCheckDefaultEstado`}>
              Activo
            </label>

            <div className="form-text mb-3">
              Cuando el concurso tiene "tildado" Activo, significa que se muestra en la plataforma. Caso contrario, no se muestra
            </div>

          </div>          

          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
            <button disabled={saving} className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">
              {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
              <span role="status">Guardar</span>
            </button>
            <Link className="btn btn-success px-4" to={`/oferta/${id}`}>Ver</Link>
            <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
          </div>

        </form>
      </main>
      </>
      )
    }
     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default OfertaForm;